<template>
  <div>
    <div class="slider--div">
      <vue-slick-carousel
        v-if="filteredArray && filteredArray.length > 0"
        v-bind="settings"
        class="carousel___div"
      >
        <v-img
          v-for="(slide, i) in filteredArray"
          :key="i"
          :src="slide.image"
          class="slick-slider__image"
        ></v-img>
      </vue-slick-carousel>
    </div>
    <div v-if="false">
      <v-carousel
        height="auto"
        cycle
        interval="4000"
        hide-delimiter-background
        show-arrows-on-hover
        delimiter-icon="mdi-minus"
      >
        <v-carousel-item
          v-for="(slide, i) in homeBanners"
          :key="i"
          :to="
            slide?.redirect
              .replace('event-page', 'sportsbook')
              .replace('competition', 'sportsbook')
          "
          :src="slide?.image"
          :lazy-src="slide?.image"
          alt="fairplay banner"
          cover
          :aspect-ratio="900 / 190"
        ></v-carousel-item>
      </v-carousel>
    </div>
  </div>
</template>

<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        dots: false,
        infinite: true,
        speed: 500,
        initialSlide: 0,
        arrows: false,
        autoplay: true,
        responsive: [
          {
            breakpoint: 1600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      }
    }
  },
  computed: {
    homeBanners() {
      return this.$store.state.home.homeBanner?.inPlaySlidingBanners
    },
    filteredArray() {
      return this.homeBanners?.filter((item) => item)
    }
  },
  created() {
    this.$store.dispatch('home/getAllHomeBanner')
  }
}
</script>

<style lang="scss">
.v-carousel {
  border-radius: 4px;
}

.v-carousel__controls {
  display: none !important;
}

.v-window__next {
  display: none !important;
}

.v-window__prev {
  display: none !important;
}

.slider--div {
  height: 100px;
}

@media (min-width: 1601px) {
  .slider--div {
    height: 365px;
  }
}

@media (min-width: 1921px) {
  .slider--div {
    height: 420px;
  }
}

@media (min-width: 2559px) {
  .slider--div {
    height: 555px;
  }
}

@media (min-width: 768px) {
  .carousel___div > .slick-list > .slick-track {
    gap: 15px !important;
  }
}
.carousel___div > .slick-list > .slick-track {
  display: flex;
  align-items: center;
  gap: 0px;
}
</style>
